/**
 * Генератор пароля для staff-SPA: формат `AbCd12-AbCd12-AbCd12` —
 * 3 группы по 6 символов (2 строчных, 2 прописных, 2 цифры), группы через дефис.
 * Крипто-случайный (`crypto.getRandomValues`), без спецсимволов.
 */

const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const DIGITS = '0123456789';

export const STAFF_PASSWORD_GROUPS = 3;
export const STAFF_PASSWORD_GROUP_SIZE = 6;

/** Равномерная выборка без modulo-bias (rejection sampling). */
function randomUIntBelow(maxExclusive: number): number {
  const limit = Math.floor(0x100000000 / maxExclusive) * maxExclusive;
  const buf = new Uint32Array(1);
  let v = 0;
  do {
    crypto.getRandomValues(buf);
    v = buf[0]!;
  } while (v >= limit);
  return v % maxExclusive;
}

function pickOne(chars: string): string {
  return chars[randomUIntBelow(chars.length)]!;
}

function randomGroup(): string {
  const chars = [pickOne(LOWER), pickOne(LOWER), pickOne(UPPER), pickOne(UPPER), pickOne(DIGITS), pickOne(DIGITS)];
  for (let i = chars.length - 1; i > 0; i -= 1) {
    const j = randomUIntBelow(i + 1);
    const a = chars[i]!;
    const b = chars[j]!;
    chars[i] = b;
    chars[j] = a;
  }
  return chars.join('');
}

/** Возвращает пароль вида `AbCd12-AbCd12-AbCd12` (каждая группа: 2 строчных + 2 прописных + 2 цифры). */
export function generateStaffPassword(): string {
  return Array.from({ length: STAFF_PASSWORD_GROUPS }, () => randomGroup()).join('-');
}
